
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wing/support",
      function () {
        return require("private-next-pages/wing/support/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wing/support"])
      });
    }
  